export default __webpack_public_path__ + "static/media/Sume_AliciaCarrillo.4c375576.png";